import { PrivacyLevelEnum, type Item } from "@/services/fobizzToolsApi";
import { flash } from "@/utils/flash";

export const useItemPrivacyUtils = () => {
  const { t } = useI18n();
  const { useUpdateMutation } = useItemQueries();

  const isPrivateItem = (item: Item) => {
    return item.privacyLevel === PrivacyLevelEnum.LOCKED;
  };

  const { items: itemsService } = useApiClient();

  const remix = async (item: Item, flashMessage?: string) => {
    const newItem = await itemsService.remixSync({
      objId: item.id,
      objType: item.kind,
    });

    const message = flashMessage || t("schoolClass.flash.remixedItem");
    const updatedItem = await updatePrivacyIfLocked(newItem, message);
    if (!updatedItem) {
      flash(FlashKindEnum.INFO, message);
    }

    return updatedItem || newItem;
  };

  const updatePrivacyIfLocked = async (item: Item, flashMessage?: string) => {
    if (!isPrivateItem(item)) {
      return;
    }

    const mutation = useUpdateMutation({
      id: item.id,
      kind: item.kind,
    });

    const updatedItem = await mutation.mutateAsync({
      privacyLevel: PrivacyLevelEnum.SECRET,
    });

    flash(
      FlashKindEnum.INFO,
      flashMessage || t("schoolClass.flash.privateItem")
    );

    return updatedItem;
  };

  return { remix, updatePrivacyIfLocked };
};
